<script setup lang="ts">
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'

withDefaults(
  defineProps<{
    signatureName: string
    signatureRole: string
    signatureStamp: string
    year: number
    isBlackBelt?: boolean
  }>(),
  {
    signatureName: '',
    signatureRole: '',
    signatureStamp: '',
    year: new Date().getFullYear(),
    isBlackBelt: false,
  },
)
</script>

<template>
  <div class="flex justify-between items-end gap-x-10">
    <!-- Signature -->
    <div class="relative flex flex-col items-center">
      <div :class="['relative signature', isBlackBelt ? 'text-light-text-100' : 'text-dark-text-100']">
        <div class="absolute -top-1 -end-4 rotate-[9deg] w-[35px] h-[35px]">
          <ImageThumbnail
            v-if="signatureStamp"
            resize-strategy="fit"
            :original-image-width="100"
            :original-image-height="100"
            :process-image="true"
            :src="signatureStamp"
            alt="Signature stamp"
            :style="{ mixBlendMode: 'color' }"
          />
        </div>
        <span class="relative">
          {{ signatureName }}
        </span>
      </div>
      <div :class="['field-label pt-1 px-20', isBlackBelt ? 'text-light-text-200' : 'text-dark-text-200']">
        {{ signatureRole }}
      </div>
    </div>
    <!-- Date -->
    <div class="flex flex-col items-center min-w-[138px]">
      <div :class="['date', isBlackBelt ? 'text-light-text-100' : 'text-dark-text-100']">{{ year }}</div>
      <div :class="['field-label pt-1 px-4', isBlackBelt ? 'text-light-text-200' : 'text-dark-text-200']">
        {{
          // don't translate this for now
          'Year'
        }}
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '@@/styles/la_belle_aurore.scss';
@import '@@/styles/eb_garamond.scss';
@import '@@/styles/caveat_brush.scss';
@import '@@/styles/3/partials/fonts/_shantell.scss';

.signature {
  position: absolute;
  top: 0;
  transform: translateY(-80%);
  font-family: 'La Belle Aurore', cursive;
  font-size: 28px;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: 1%;
  text-align: center;
}

.date {
  font-family: 'Caveat Brush', 'Shantell Sans', 'Comic Sans MS', cursive;
  font-size: 17px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 5%;
  text-align: center;
}

.field-label {
  font-family: 'EB Garamond', serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 12px;
  text-align: center;
  border-top: 1px solid currentColor;
}
</style>
